/**
 * BookingAvatars.tsx
 * Assignee avatar chips rendered at the right end of a booking bar
 * (Machine Schedule UX — M6). Deterministic per-person color from initials.
 */

import React from 'react';
import { AvatarGroup, Avatar, Tooltip } from '@mui/material';
import type { BookingAssignee } from '../../types/schedule';

/** Deterministic, readable color derived from a person's initials. */
function colorForInitials(initials: string): string {
  let hash = 0;
  for (let i = 0; i < initials.length; i += 1) {
    hash = (hash * 31 + initials.charCodeAt(i)) % 360;
  }
  return `hsl(${hash}, 42%, 42%)`;
}

interface BookingAvatarsProps {
  assignees: BookingAssignee[];
  max?: number;
}

export const BookingAvatars: React.FC<BookingAvatarsProps> = ({ assignees, max = 3 }) => (
  <AvatarGroup
    max={max}
    sx={{
      '& .MuiAvatar-root': { width: 18, height: 18, fontSize: 9, fontWeight: 700 },
    }}
  >
    {assignees.map((a) => (
      <Tooltip key={a.UserKey} title={a.Name}>
        <Avatar sx={{ bgcolor: colorForInitials(a.Initials) }}>{a.Initials}</Avatar>
      </Tooltip>
    ))}
  </AvatarGroup>
);
